import { BillingCadenceOrder } from '@fruitful/types';
import React from 'react';
import { BodyMediumRegular } from 'smoothie';

import { getCadenceDisplayString } from '../../../common/utils/billUtils';
import { BillingCadence } from '../../types/Bill';
import type { BillDetailsEditTypeProps } from '../edit/BillDetailsEditContainer';
import { SelectableRow } from './BillRows';

const BillEditFrequency = ({ bill, onChange }: BillDetailsEditTypeProps) => {
    return (
        <>
            {Object.values(BillingCadence)
                .filter(
                    (cadence) =>
                        cadence !== BillingCadence.UNKNOWN &&
                        cadence !== BillingCadence.YEARLY,
                )
                .sort((a, b) => {
                    return BillingCadenceOrder[a] - BillingCadenceOrder[b];
                })
                .map((cadence, i) => {
                    return (
                        <SelectableRow
                            key={i}
                            isSelected={cadence === bill.cadence}
                            isMultiSelect={false}
                            isFirstRow={i === 0}
                            onSelect={() => {
                                const newBill = { ...bill, cadence };
                                onChange(newBill);
                            }}
                            rowContentComponent={
                                <BodyMediumRegular padding={8}>
                                    {getCadenceDisplayString(cadence)}
                                </BodyMediumRegular>
                            }
                        />
                    );
                })}
        </>
    );
};

export default BillEditFrequency;
